<ng-template #filterPopoverTemplate>
    <div class="filter-popover-content" [formGroup]="sortForm">
        <div>
            <label>Sortera efter</label>
            <ng-select
                bindLabel="label"
                bindValue="value"
                [items]="sortOptions"
                formControlName="method">
            </ng-select>
        </div>

        <div>
            <label>Ordning</label>
            <ng-select
                [clearable]="false"
                bindLabel="label"
                bindValue="value"
                [items]="sortDirectionOptions"
                formControlName="direction">
            </ng-select>
        </div>
    </div>
</ng-template>

<i
    #filterPopover="ngbPopover"
    class="fa-solid fa-filter"
    role="button"
    title="Filtrering och sortering"
    [ngbPopover]="filterPopoverTemplate"
    popoverClass="alert-list-filter-popover"
    autoClose="outside"
    placement="bottom-end"></i>